import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../styles/landing.css';
import {
  LandingNav,
  LandingHero,
  TrustedBy,
  FeaturesSection,
  HowItWorks,
  PricingSection,
  LandingFinalCta,
  LandingFooter,
} from '../components/landing';

const Landing = ({ user, onLoginClick, onDashboardClick }) => {
  const [packages, setPackages] = useState([]);

  const onNavigate = (e, sectionId) => {
    e.preventDefault();
    const root = document.querySelector('.landing-page');
    const element = document.getElementById(sectionId);
    if (!element || !root) return;
    const top = element.offsetTop - 8;
    root.scrollTo({ top, behavior: 'smooth' });
  };

  useEffect(() => {
    api.getPublicPackages()
      .then((res) => setPackages(res.packages || []))
      .catch(() => setPackages([]));
  }, []);

  return (
    <div className="landing-page">
      <LandingNav
        user={user}
        onLoginClick={onLoginClick}
        onDashboardClick={onDashboardClick}
        onNavigate={onNavigate}
      />

      {/* Screen 1 — Hero only (no next-section peek) */}
      <section className="lp-screen lp-screen-hero" aria-label="Hero">
        <LandingHero
          user={user}
          onLoginClick={onLoginClick}
          onDashboardClick={onDashboardClick}
        />
        <TrustedBy />
      </section>

      {/* Screen 2 — Features */}
      <section id="features" className="lp-screen" aria-label="Features">
        <FeaturesSection />
      </section>

      {/* Screen 3 — How it works */}
      <section id="community" className="lp-screen" aria-label="How it works">
        <HowItWorks />
      </section>

      {/* Screen 4 — Pricing */}
      <section id="pricing" className="lp-screen" aria-label="Pricing">
        <PricingSection packages={packages} onLoginClick={onLoginClick} />
      </section>

      {/* Screen 5 — Final CTA */}
      <section className="lp-screen lp-screen-cta" aria-label="Get started">
        <LandingFinalCta
          user={user}
          onLoginClick={onLoginClick}
          onDashboardClick={onDashboardClick}
        />
      </section>

      <LandingFooter onNavigate={onNavigate} onLoginClick={onLoginClick} />
    </div>
  );
};

export default Landing;
